/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function DeviceTablet(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M192,24H64A24.0275,24.0275,0,0,0,40,48V208a24.0275,24.0275,0,0,0,24,24H192a24.0275,24.0275,0,0,0,24-24V48A24.0275,24.0275,0,0,0,192,24ZM64,40H192a8.00917,8.00917,0,0,1,8,8v8H56V48A8.00917,8.00917,0,0,1,64,40ZM192,216H64a8.00917,8.00917,0,0,1-8-8v-8H200v8A8.00917,8.00917,0,0,1,192,216Z" />
    </Svg>
  );
}

export default DeviceTablet;
